<template>
    <!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In  -->
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="269.2"
        height="85.9"
        class="svg-logo"
        viewBox="0 0 269.2 85.9"
        style="enable-background:new 0 0 269.2 85.9;"
        xml:space="preserve"
    >
        <title>Renode Luxe</title>
        <g id="logo_1_">
            <g v-for="(item, chara) in paths" :id="'logo_'+chara" :key="chara">
                <g v-for="(path, number) in item" :key="number" :id="'logo_'+chara+'_'+number">
                    <clipPath :id="'clip_'+chara+'_'+number">
                        <path :d="path.clip" />
                    </clipPath>
                    <path
                        :id="'path_'+chara+number"
                        class="stroke"
                        :class="{
                            start:count>path.index,
                            long:path.long
                        }"
                        :d="path.path"
                        :style="{
                            'clip-path':'url(#clip_'+chara+'_'+number+')',
                            'stroke-width':path.width
                            }"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import paths from "../assets/path.json";

export default {
    name: "logo-svg",
    data: function () {
        return {
            paths: paths,
        };
    },
    props: {
        count: {
            type: Number,
        },
    },
};
</script>

<style lang="scss">
.svg-logo {
    width: 100%;
}

.stroke {
    fill: none;
    stroke: #000000;
    stroke-linecap: round;
    /*stroke-miterlimit: 10;*/
    stroke-width: 5;
    stroke-dasharray: 300;
    stroke-dashoffset: 450;
}

@media all and (-ms-high-contrast: none) {
    .stroke {
        fill: #000000;
        stroke-dashoffset: 0;
    }
}

.stroke.start {
    animation: path 2s linear forwards;
}

.stroke.start.long {
    animation-duration: 0.7s;
}

// TODO: 2つ目のeのアニメーションが逆向きになってるので直したい

@keyframes path {
    0% {
        stroke-dashoffset: 300;
    }
    100% {
        stroke-dashoffset: 0;
    }
}
</style>
